import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueRouter from 'vue-router'
import Routers from './router'
//import GlobalComp from './GlobalComponents'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuex from 'vuex'
import { store } from './store'
import Notifications from 'vue-notification'

Vue.use(require('vue-pusher'), {
  api_key: '27bc8440d6baccee8ab4',
  options: {
      cluster: 'ap2',
      encrypted: true,
      authEndpoint: 'http://esource.shreegrgoilmill.com/backend/public/broadcasting/auth',
      auth:{  
        headers:{
            Authorization : 'Bearer '+store.state.token,
        }
      }
  },
});
Vue.use(Notifications)
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(VueAxios, axios)
Vue.config.productionTip = false



// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
export var bus = new Vue();
const router = new VueRouter({
  routes : Routers,
  mode: 'history'
})

axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.token
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.loggedIn) {
      next({
        name: 'login',
      })
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.requiresVisitor)) {
    if (store.getters.loggedIn) {
      next({
        name: 'dashboard',
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

new Vue({
  vuetify,
  store: store,
  router,
  //components: GlobalComp,
  render: h => h(App)
}).$mount('#app')
